// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1muwf","errorLogs":"styles_errorLogs__iW04t"};